/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { GetBasicUserResponse } from '@mta/vela-api-types'
import { useHydrateAtoms } from 'jotai/utils'
import { jwtDecode } from 'jwt-decode'
import React from 'react'

import { sessionAtom } from '@/store/session'

/** A description of the available properties for this component. */
type SessionHydrationProps = {
  /** The access token to use. */
  accessToken: string | undefined

  /** Any user information. */
  userInformation: GetBasicUserResponse | undefined
}

/**
 * Hydrates the session atom with the provided access token and user information.
 */
const SessionHydration: React.FC<SessionHydrationProps> = ({ accessToken, userInformation }) => {
  const decodedJwt = accessToken ? jwtDecode(accessToken) : null

  useHydrateAtoms([
    [
      sessionAtom,
      accessToken && decodedJwt && userInformation
        ? {
            accessToken,
            userId: userInformation.id,
            email: userInformation.email,
            firstName: userInformation.firstName,
            lastName: userInformation.lastName,
            company: userInformation.company,
          }
        : undefined,
    ],
  ])

  return null
}

export { SessionHydration }
